import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { ChangeDecision } from '@/components/approvals/change-decision';
import {
  ChangeAlerts,
  ChangeAmount,
  ChangeBody,
  ChangeMeta,
  ChangeStatus,
  hasChangeAlerts,
} from '@/components/approvals/change-parts';
import { QueryState } from '@/components/feedback/query-state';
import { SkeletonSheet } from '@/components/feedback/skeletons';
import { PageHeader } from '@/components/page-header';
import { adminQuery } from '@/lib/query';

export const Route = createFileRoute('/_app/approvals/$requestId')({
  component: ChangePage,
});

/** One change request on its own page: the same parts as the sheet. */
function ChangePage() {
  const { requestId } = Route.useParams();
  const query = useQuery(adminQuery('changes.get', { request_id: requestId }));
  return (
    <QueryState query={query} label="this request" skeleton={<SkeletonSheet />}>
      {(change) => (
        <div className="flex max-w-3xl flex-col gap-6">
          <PageHeader
            title={change.title}
            actions={
              <>
                <ChangeAmount change={change} />
                <ChangeStatus change={change} />
              </>
            }
          />
          <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-muted-foreground">
            <ChangeMeta change={change} />
          </p>
          {hasChangeAlerts(change) ? <ChangeAlerts change={change} /> : null}
          <ChangeBody change={change} />
          <div className="rounded-lg border border-border bg-card p-4">
            <ChangeDecision change={change} />
          </div>
        </div>
      )}
    </QueryState>
  );
}
